<template>
  <div>
    <section id="scrolly-portada">
      <div id="fondo-portada" :class="{ simplificado: simplificado_activo }">
        <PortadaMapa :paso_inicial="paso" :id="'contenedor-mapa'" />
        <PortadaAves :paso_inicial="paso" :id="'contenedor-aves'" />
        <PortadaTequesquite :paso_inicial="paso" :id="'contenedor-tequesquite'" />
        <PortadaPodremosLograr :paso_inicial="paso" :id="'contenedor-portada-podremos-lograr'" />
        <PortadaEspacioNatural :paso_inicial="paso" :id="'contenedor-portada-espacio-natural'" />
        <PortadaEvidenciaCientifica
          :paso_inicial="paso"
          :id="'contenedor-portada-evidencia-cientifica'"
        />
      </div>
      <article :class="{ simplificado: simplificado_activo }">
        <div class="step portada" data-step="1">
          <div
            class="bullet visible-normal"
            :style="{
              display: `${simplificado_activo ? 'none' : 'inherit'}`,
              background: simplificado_activo
                ? 'none'
                : 'linear-gradient(transparent,rgba(0,0,0,' + posicion_y_normalizada + '))',
            }"
          >
            <h1 class="cover-title a11y-contraste-fondo">
              <span class="a11y-contraste-fondo"> Rescate del Lago de Texcoco </span>
            </h1>
            <p class="cover-subtitle">
              <span class="a11y-contraste-fondo">
                Un capítulo del Ecosistema Nacional Informático de Sistemas Socioecológicos
              </span>
            </p>
          </div>
          <div class="bullet container text m-t-2 m--b-1 visible-simplificado">
            <h2 class="titular-portada m-t-3-sm m-t-4-md m-x-auto">Rescate del Lago de Texcoco</h2>
            <h2 class="titular-portada sub m-x-auto">
              Un capítulo del Ecosistema Nacional Informático de Sistemas Socioecológicos
            </h2>
          </div>
        </div>
        <!-- inician Bullets nuevos-->
        <div
          class="step step-2"
          data-step="2"
          :style="{
            background: simplificado_activo
              ? 'none'
              : 'linear-gradient(rgba(0,0,0,' + posicion_y_normalizada + '),transparent)',
          }"
        >
          <p class="bullet">
            Hace 500 años, esta zona albergó el sistema de lagos de la <b> Cuenca de México</b>,
          </p>
        </div>
        <div class="step" data-step="3">
          <p class="bullet">
            para 2010, después de varios procesos de desecación y urbanización,
            <b> estos son los únicos cuerpos de agua restantes,</b> entre ellos el Lago de Texcoco.
          </p>
        </div>
        <!-- terminan Bullets nuevos-->
        <div class="step" data-step="4">
          <p class="bullet">
            Como parte de estos procesos, en 2016 se inició la
            <b>construcción del antiguo aeropuerto</b> (exNAICM) que contemplaba una superficie de 4
            mil 430 hectáreas;
          </p>
        </div>
        <div class="step" data-step="5">
          <p class="bullet">
            esta construcción se enmarca dentro de la Zona Federal del Lago de Texcoco,
            <b> el vaso regulador más importante de la Cuenca de México</b>, el cual abarca más de
            12 mil hectáreas,
          </p>
        </div>
        <div class="step" data-step="6">
          <p class="bullet">
            pero el <b> impacto ambiental </b> afecta alrededor de 639 mil hectáreas...
          </p>
        </div>
        <div class="step" data-step="7">
          <p class="bullet">... más que la extensión territorial de <b>Colima</b>.</p>
        </div>
        <div class="step" data-step="8">
          <p class="bullet">
            El rescate del Lago de Texcoco es una oportunidad histórica; representa el
            <span style="font-weight: 700">hogar de más de 250 especies de aves</span> y sus
            sedimentos lacustres son únicos en el mundo.
          </p>
        </div>
        <div class="step" data-step="9">
          <p class="bullet">
            Además, es la historia de pueblos originarios que se sustentan de la
            <span style="font-weight: 700">extracción del tequesquite, ahuautle y romerito.</span>
          </p>
        </div>
        <div class="step" data-step="10">
          <p class="bullet">
            Podremos lograr este <b>rescate y reconstrucción con la participación</b> de habitantes
            de la zona, gobierno, organizaciones sociales y la comunidad de humanidades, ciencias y
            tecnologías.
          </p>
        </div>
        <div class="step" data-step="11">
          <p class="bullet">
            Y al hacerlo, estaremos contribuyendo a la preservación de un espacio natural; un
            laboratorio vivo único en el mundo.
          </p>
        </div>
        <div class="step" data-step="12">
          <p class="bullet">
            Para conseguirlo, el Conahcyt pone a disposición de la ciudadanía y de las instituciones
            gubernamentales la <b>evidencia científica</b>.
          </p>
        </div>
      </article>
    </section>
  </div>
</template>

<script>
import scrollama from "scrollama";
import PortadaMapa from "@/components/componentes-texcoco/PortadaMapa.vue";
import PortadaAves from "@/components/componentes-texcoco/PortadaAves.vue";
import PortadaTequesquite from "@/components/componentes-texcoco/PortadaTequesquite.vue";
import PortadaPodremosLograr from "@/components/componentes-texcoco/PortadaPodremosLograr.vue";
import PortadaEspacioNatural from "@/components/componentes-texcoco/PortadaEspacioNatural.vue";
import PortadaEvidenciaCientifica from "@/components/componentes-texcoco/PortadaEvidenciaCientifica.vue";
import * as d3 from "d3";

export default {
  name: "PortadaScroll",
  components: {
    PortadaMapa,
    PortadaAves,
    PortadaTequesquite,
    PortadaPodremosLograr,
    PortadaEspacioNatural,
    PortadaEvidenciaCientifica,
  },
  data: function () {
    return {
      paso: 1,
      posicion_y_normalizada: 1,
    };
  },
  mounted() {
    this.inizializandoScrollama();
    window.addEventListener("scroll", this.reducirDegradadoConScroll);
  },
  computed: {
    simplificado_activo() {
      return this.$store.getters.tieneVistaSimplificada;
    },
  },
  methods: {
    reducirDegradadoConScroll() {
      if (window.pageYOffset < window.innerHeight) {
        this.posicion_y_normalizada =
          (window.innerHeight - window.pageYOffset) / window.innerHeight;
        // console.log(this.posicion_y_normalizada);
      }
    },
    inizializandoScrollama() {
      this.scrolly = d3.select("#scrolly-portada");
      this.fondo_portada = this.scrolly.select("div#fondo-portada");
      this.step = this.scrolly.select("article").selectAll(".step");

      this.scroller = scrollama();
      this.scroller
        .setup({
          step: "#scrolly-portada .step",
          offset: 0.1,
          debug: false,
        })
        .onStepEnter(this.cambiandoPaso);

      this.reescalandoPantalla();

      window.addEventListener("resize", this.reescalandoPantalla);
    },
    reescalandoPantalla() {
      var stepH = Math.floor(window.innerHeight * 0.95);
      //this.step.style("min-height", this.simplificado_activo ? "inherit" : stepH + "px");
      /*
      var altura_fondo_portada = window.innerHeight / 2;
      var margin_top_fondo_portada = (window.innerHeight - altura_fondo_portada) ;

      this.fondo_portada
        .style("height", altura_fondo_portada + "px")
        .style("top", margin_top_fondo_portada + "px");
      */
      // 3. tell scrollama to update new element dimensions
      this.scroller.resize();
    },
    cambiandoPaso(response) {
      this.paso = response.index + 1;
      this.step.classed("activo", function (d, i) {
        return i === response.index;
      });
      this.fondo_portada.select("p").text(response.index + 1);
      if (this.paso == 1) {
        d3.select("div#fondo-portada")
          .transition()
          .duration(200)
          .style("background-color", "#8a8a8a");
      } else if (this.paso == 2) {
        d3.select("div#fondo-portada")
          .transition()
          .duration(200)
          .style("background-color", "#8a8a8a");
      } else if (this.paso == 3) {
        d3.select("div#fondo-portada")
          .transition()
          .duration(200)
          .style("background-color", "#8a8a8a");
      } else if (this.paso == 4) {
        d3.select("div#fondo-portada")
          .transition()
          .duration(200)
          .style("background-color", "#8a8a8a");
      } else if (this.paso == 5) {
        d3.select("div#fondo-portada")
          .transition()
          .duration(200)
          .style("background-color", "#8a8a8a");
      } else if (this.paso == 6) {
        d3.select("div#fondo-portada")
          .transition()
          .duration(200)
          .style("background-color", "#8a8a8a");
      } else if (this.paso == 7) {
        d3.select("div#fondo-portada")
          .transition()
          .duration(200)
          .style("background-color", "#8a8a8a");
      } else if (this.paso == 8) {
        d3.select("div#fondo-portada")
          .transition()
          .duration(200)
          .style("background-color", "#98ECD5");
      } else if (this.paso == 9) {
        d3.select("div#fondo-portada")
          .transition()
          .duration(200)
          .style("background-color", "#021B24");
      } else if (this.paso == 10) {
        d3.select("div#fondo-portada").transition().duration(200).style("background-color", "#000");
      } else if (this.paso == 11) {
        d3.select("div#fondo-portada").transition().duration(200).style("background-color", "#000");
      } else if (this.paso == 12) {
        d3.select("div#fondo-portada").transition().duration(200).style("background-color", "#000");
      } else if (this.paso == 13) {
        d3.select("div#fondo-portada").transition().duration(200).style("background-color", "#000");
      } else if (this.paso == 14) {
        d3.select("div#fondo-portada").transition().duration(200).style("background-color", "#000");
      }
    },
  },
};
</script>

<style scoped lang="scss">
img.logos {
  display: flex;
  margin: auto;
  margin-top: 200px;
  @media (min-width: map-get($media-queries-limit, "mobile")) {
    width: 400px;
  }
}

div#fondo-portada {
  position: -webkit-sticky;
  position: sticky;
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
  background-color: #8a8a8a;
  z-index: 0;
  height: 100vh;
  top: 0;
  width: 100%;
  left: 0;
  p {
    margin: 0;
  }
  &.simplificado {
    opacity: 0;
    height: 100vh;
    position: absolute;
  }
}

#scrolly-portada {
  position: relative;
  article {
    top: -100vh;
    padding: 0;
    color: #fff;
    @media (max-width: map-get($media-queries-limit, "mobile")) {
      top: -100vh;
      padding: 0;
    }
    position: relative;
    padding: 0;

    margin: 0 auto;
    h1 {
      text-align: center;
      margin: 10px auto 10px auto;
      max-width: 450px;
      font-size: 52px;
      line-height: 60px;
      @media (max-width: map-get($media-queries-limit, "mobile")) {
        font-size: 36px;
        line-height: 38px;
      }
    }
    p.cover-subtitle {
      color: #fff;
      font-size: 30px;
      text-align: center;
      max-width: 450px;
      margin-top: 10px;
      margin-bottom: 70px;
      margin-left: auto;
      margin-right: auto;
      font-size: 21px;
      @media (max-width: map-get($media-queries-limit, "mobile")) {
        font-size: 16px;
        margin-top: 0px;
      }
    }
    div.step {
      &.step-2 {
        background: linear-gradient(#000, transparent, transparent, transparent);
      }
      height: 100vh;
      position: relative;
      display: block;
      .bullet {
        &.visible-simplificado {
          display: none;
        }
        &.visible-normal {
          display: block;
        }
        background-color: rgba(0, 0, 0, 0.95);
        padding: 0.5em;
        color: #fff;
        position: relative;
        margin: 0 32px;
        top: 95%;
        @media (min-width: map-get($media-queries-limit, "mobile")) {
          margin-right: auto;
          margin-left: auto;
          max-width: 31em;
        }
      }
      p.bullet {
        text-align: center;
        font-size: 18px;
        @media (max-width: map-get($media-queries-limit, "mobile")) {
          font-size: 16px;
        }
      }
      &.activo {
        .bullet {
          background-color: rgba(0, 0, 0, 0.95);
        }
      }
      div.bullet {
        background-color: rgba(0, 0, 0, 0.95);
        padding: 8px;
        color: #fff;
      }
      &.activo {
        div.bullet {
          color: #fff;
          background-color: rgba(0, 0, 0, 0.95);
        }
      }
      &.portada,
      &.portada.activo {
        height: calc(100 * var(--vh) - 100px);
        position: relative;
        display: block;
        .bullet {
          width: 100%;
          max-width: 100%;
          margin: 0;
          position: absolute;
          bottom: 0;
          top: inherit;
          background-color: none;
        }
      }
      &.portada {
        margin-top: 0px;
        @media (min-width: map-get($media-queries-limit, "mobile")) {
          margin-top: 0px;
        }
      }
    }
    &.simplificado {
      top: 0;
      div.step {
        height: inherit;
        &.portada,
        &.portada.activo {
          height: calc(100 * var(--vh) - 100px);
          margin-top: -450px;
        }
        p.bullet {
          text-align: left;
        }
        .bullet {
          &.visible-simplificado {
            display: block;
          }
          &.visible-normal {
            display: none;
          }
          background-color: #fff;
          color: #000;
          img.logos-color {
            max-width: 700px;
            margin: 0 auto;
            display: flex;
          }
        }
        &.activo {
          div.bullet {
            color: #000;
            background-color: #fff;
          }
        }
      }
    }
  }
}
</style>
